import './seeall.css';

export function SeeAllButton({ onClick, isExpanded }) {
    return (
        <div className='button-div'>
            <button className={`button ${isExpanded ? 'expanded' : ''}`}  onClick={onClick}>
                {isExpanded ? 'See Less' : 'See All'}
            </button>
        </div>
    );
}



